export default "__VITE_ASSET__99116e0f__"